var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSblast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5391 15.9262L27.624 13.8908L29.032 9.56892L26.2159 7.51953H7.46468L3.12891 10.74H25.1703L23.9992 14.3648H15.1603L14.3099 17.0136H23.1488L20.6672 24.6396L24.8078 22.5902L26.2856 18.0174L23.5112 15.982L23.5391 15.9262Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36103 21.3626L11.9123 13.416L9.08221 11.2969L4.83008 24.6388H20.6675L21.7271 21.3626H9.36103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSblast);
export default __webpack_public_path__ + "static/media/sblast.4033a21da3dd1bb0a597a4b2702b6747.svg";
export { ForwardRef as ReactComponent };